/**
 * MultiMeshInstance2D registration: the parser, which reuses the Node2D parse.
 * linterParser.ts holds the property validators.
 */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseNode2D } from '../../base/node2d/parser';
const multiMeshInstance2DRegistration = {
    typeName: 'MultiMeshInstance2D',
    parser: parseNode2D,
};
nodeRegistry.register(multiMeshInstance2DRegistration);
//# sourceMappingURL=index.js.map